module.exports = __webpack_public_path__ + "static/team-work-2007f023e5f5f40939ad2157fcbbc885.png";